import React, { Component } from 'react';
import { connect } from 'react-redux';
import { registeredPhonesActions } from '../actions/registered-phones.actions';
// eslint-disable-next-line
import { Badge, Button, Input, List, Row, Col, Alert, Spin, Upload, Icon, Tooltip, Popover } from 'antd';
import { dspxSorter } from '../helpers/dspx-sort';
import { CommentIcon } from '../resource/icons';
import { setRefreshFn } from '../actions/refreshActions';

class RegisteredPhonesPanelContainer extends Component {
	constructor(props) {
		super(props)

		this.state = {
			phones: [],
			dataFetching: false,
		}
	}

	getPhonesList = () => {

		this.setState({ dataFetching: true })

		registeredPhonesActions.fetchPhones()
			.then(
				data => {				
					this.setState({ phones: data.data, dataFetching: false })
				},
				err => { this.setState({ dataFetching: false }); console.log(err) })
	}

	componentDidMount() {
		this.getPhonesList();

		this.props.dispatch(setRefreshFn(this.getPhonesList))
	}

	render() {

		return (
			<div style={{ marginBottom: '20px', textAlign: 'left', paddingLeft: '20px', }}>
				<h4>Подключенные телефоны</h4>
				{this.props.apiResponseError && <Alert message={this.props.apiResponseText} type="error" showIcon />}

						<Spin size="large" spinning={this.state.dataFetching} tip="Загрузка..." delay={100}>
							{(this.state.phones && this.state.phones.length > 0 &&
								<List style={{ paddingLeft: '0px', marginTop: '0px' }} 
									className='dspx-registered-phones-list'
									itemLayout="vertical"
									size="small"
									bordered={false}
									pagination={{
										hideOnSinglePage: true,
										pageSize: 15,
										size: 'small',
									}}
									dataSource={this.state.phones}
									renderItem={item => {

										return (
											<List.Item key={item.domain+'_'+item.userName}
												className='dspx-registered-phones-list-item'
											>
												<Row>
												<Col span={8} style={{textAlign:'left'}}>
												    <Badge status={ item.state == 'Registered' ? "success" : "error"} />
														{item.userName}
													</Col>
													<Col span={8} style={{textAlign:'left'}}>
														{item.domain}
													</Col>
													<Col span={8} style={{textAlign:'left'}}>
														{item.state}
													</Col>
													</Row>
											</List.Item>
										)
									}}
								/>) || <div style={{ marginTop: '8px', fontSize: '11px', color: '#ccc' }}>нет данных</div>}
						</Spin>
			</div>
		)
	}
}

function mapStateToProps(state) {

	const { registeredPhonesStore } = state;

	return {...registeredPhonesStore};
}

export default connect(mapStateToProps)(RegisteredPhonesPanelContainer);